<app-pagination *ngIf="currentPageIndex !== undefined"
                (pageChanged)="pageChanged($event)"
                [currentPageIndex]="currentPageIndex"
                [pagesLength]="pagesLength"
                [selectablePages]="selectablePages"
                [currentPageControl]="currentPageControl"
></app-pagination>
